import React, { useState, useContext, useEffect } from "react";
import Graph from "./Graph";
import "./Style.css";
import Tab from "./Tab";
import dataContext from "../../../context/dataContext";
let formatDate = (date) => {
  let year = new Date(date).getFullYear().toString().slice(2, 4);
  let month = (new Date(date).getMonth() + 1).toString();
  let day = new Date(date).getDate().toString();
  let newDate = `${month.length < 2 ? `0${month}` : month}/${day.length < 2 ? `0${day}` : day
    }/${year}`;

  return newDate;
};

const maxWPMValueForShow = 2000;

export default function GraphDashboard() {
  let { userDetails } = useContext(dataContext);
  const [userTR, setUserTR] = useState(userDetails.TR.length ? [...userDetails.TR].sort((a, b) => new Date(a.date) - new Date(b.date)) : []);
  const [userTF, setUserTF] = useState(userDetails.TF);
  const [tabs, setTabs] = useState(null);
  const [dataSrc, setDataSrc] = useState();
  const [assesmentRestData, setAssementResData] = useState({});
  const [selectedTab, setSelectedTab] = useState(2);
  const [allBooks, setAllBooks] = useState(userTR.length ? userTR.map((value) => value.bookName.trim().toLowerCase()).reduce((list, bookName) => { if (!list.includes(bookName)) { list.push(bookName) }; return list }, []) : [])
  const [bookName, setBookName] = useState(allBooks.length ? allBooks[allBooks.length - 1].trim().toLowerCase() : "");
  const [userASMT, setUserASMT] = useState(userDetails.assessments.length > 0 ? userDetails.assessments.filter((assesment) => { return Number(assesment.result?.WPM) < maxWPMValueForShow && assesment.result?.CMP && assesment.result?.STD }) : [])
  const [LPMByBook, setLPMByBook] = useState(0);
  //build the graph details
  function buildData(objName) {
    //objName contails the dots on the graph (y=as value, x=as date)
    //debugger
    //const oName = focusData[]
    let xValues = [];
    let yValues = [];
    let graphData = {};

    //initial day - the first day that we have in our dots
    let initialDay = new Date(formatDate(objName[0].date));
    //till today
    let st = new Date();
    let daysGap = st - initialDay;
    //gets the days list on the x-values
    let days = Math.floor(daysGap / (1000 * 3600 * 24)) + 1;

    // create empty graphData

    for (let index = 0; index < days; index++) {
      let tempDateRes = new Date(initialDay);
      tempDateRes = new Date(tempDateRes.setDate(initialDay.getDate() + index));
      graphData[formatDate(tempDateRes)] = "";
      xValues[index] = formatDate(tempDateRes);
    }
    // load input into graph
    //graphData will be an array that contains places for all dates on graph and has values only where we have value
    objName.map((res) => {
      //avoid save null or NaN if there is
      return (graphData[formatDate(res.date)] = res.value ? Math.floor(res.value) : (res.result.WPM == null || res.result.WPM == NaN) ? graphData[formatDate(res.date)] : res.result);
    });

    let c = 0;
    let lastVal = 0;
    let STDArr = [];
    let CMPArr = [];

    Object.keys(graphData).forEach((key) => {
      if (graphData[key] == "") {
        yValues[c] = null;
        STDArr[c] = null;
        CMPArr[c] = null;

      } else {
        if (graphData[key].WPM) {
          yValues[c] = graphData[key].WPM;
          STDArr[c] = graphData[key].STD;
          CMPArr[c] = graphData[key].CMP;
        } else {
          yValues[c] = graphData[key] > 0 ? graphData[key] : null;
        }
        lastVal = graphData[key];
      }
      c++;
    });

    // setAssementResData({ STDArr, CMPArr })
    let output = { xValues: xValues, yValues: yValues, STDArr, CMPArr };
    return output;
  }
  //
  function clearASS() {
    let ass = [...userDetails.assessments]
    // ass.shift()
    return ass.length > 0 ? (ass[ass?.length - 1].result?.WPM)?.toFixed(0) : 0
  }

  function lastsParamsValues() {
    const ass = userASMT.length > 0 ? Number((userASMT[userASMT?.length - 1].result?.WPM))?.toFixed(0) : 0;
    // const ass = clearASS();//TODO: dont forget to delete this func
    const read = userTR[userTR?.length - 1]?.value || 0;
    let lastTFValue = userDetails?.TF.length ? buildData(userDetails?.TF).yValues.map(v => Math.floor(v)).filter(v => v > 0) : []
    const focus = userDetails?.TF.length ? (lastTFValue[lastTFValue.length - 1] || 0) : 0;
    const tabParams = { ass, read, focus };
    return tabParams
  }


  useEffect(() => {
    const mainTabs = [
      {
        tabName: "Measurement",
        last: `${lastsParamsValues().ass}`,
        dataArrayName: userASMT || [],
        unit: "WPM",
      },
      {
        tabName: "Reading",
        last: `${lastsParamsValues().read}`,
        dataArrayName: sortByLastBook(userTR, bookName),
        // dataArrayName: userDetails.TR,
        unit: "LPM",
      },
      {
        tabName: "Focus",
        last: `${lastsParamsValues().focus}`,
        dataArrayName: userTF,
        unit: "CM",
      },
    ];
    setTabs(mainTabs)

  }, []);

  useEffect(() => {
    if (tabs?.length) {

      if (tabs[0].dataArrayName.length) {
        setSelectedTab(0)
      } else {

        if (tabs[2].dataArrayName.length) {
          setSelectedTab(2)
        }
      }
    }
  }, [tabs])

  useEffect(() => {
    if (!tabs) {
      return;
    }
    console.log("🚀 ~ useEffect ~ selectedTab:", selectedTab)
    if (selectedTab == 1) {

      setDataSrc(buildData(sortByLastBook(userTR, bookName)));
    } else {
      setDataSrc(buildData(tabs[selectedTab].dataArrayName));
    }

  }, [selectedTab, bookName])


  function sortByLastBook(TRResults, book) {
    if (TRResults.length == 0) {
      return []
    }
    // TRResults.sort((a, b) => new Date(a.date) - new Date(b.date));

    // Getting the last book name
    const lastBookName = TRResults[TRResults.length - 1].bookName.trim().toLowerCase();
    // setAllBooks(allBooks)
    // Filtering the array by the last book name
    const filteredByLastBook = TRResults.filter(item => book ? item.bookName.trim().toLowerCase() === book : item.bookName.trim().toLowerCase() === lastBookName);
    let tempoValue = filteredByLastBook[filteredByLastBook.length - 1]?.value
    setLPMByBook(tempoValue);
    return filteredByLastBook
  }





  return (
    <>
      <div className="Graph">
        <div className="DashGraph back-purple right">
          <div className="Tabs">
            {tabs && tabs.map((tab, index) => {
              return (
                <Tab
                  key={index + Date.now()}
                  tabName={tab.tabName}
                  last={tab.unit == "LPM" ? LPMByBook : tab.last}
                  tabUnit={tab.unit}
                  dataArrayName={tab.dataArrayName}
                  selectedTab={tabs[selectedTab].tabName}
                  tabIndex={index}
                  updateSelectedTab={setSelectedTab}

                />
              );
            })}
          </div>
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", padding: "0 1rem" }}>

            <div style={{ position: "relative", textAlign: "center", display: "block", paddingRight: "0.2rem" }}>
              {tabs && (tabs[selectedTab].unit == "WPM" ? "Weekly measure".toUpperCase() : tabs[selectedTab].unit == "LPM" ? "PUSHUP" : "Near-point".toUpperCase())}
            </div>
            {tabs && tabs[selectedTab].unit == "LPM" && <div><select
              onChange={(e) => { setBookName(e.target.value); }}
              defaultValue={bookName}
              style={{ padding: " 0.2rem ", borderRadius: "5px", border: "1px solid #ccc", color: "#575454", fontSize: "0.9rem", fontWeight: 800, fontFamily: "Times New Roman", fontStyle: "italic" }}
            >
              {allBooks.map((book, index) => (
                <option key={index} value={book}>
                  {book}
                </option>
              ))}
            </select></div>}
          </div>
          {/* <div style={{ position: "relative", textAlign: "center" }}>{tabs[selectedTab].unit == "WPM" ? "Weekly reading rate" : tabs[selectedTab].unit == "LPM" ? "Pushup reading rate " : "Near-point"} {tabs[selectedTab].unit == "LPM" && <label style={{ color: "#575454", position: "absolute", top: "160%", left: "50%", transform: "translate(-50%, -50%)", fontSize: "0.7rem", fontWeight: 800, fontFamily: "Times New Roman", fontStyle: "italic" }}> {bookName}</label>}</div> */}
          {tabs && <Graph
            data={dataSrc?.yValues || []}
            labs={dataSrc?.xValues || []}
            tabUnit={tabs[selectedTab].unit}
            moreData={{ STDArr: dataSrc?.STDArr, CMPArr: dataSrc?.CMPArr }}
          />}
        </div>
      </div>
    </>
  );
}
